export const galleryImages = [
   {
    "id": 1,
    "src": "/images/gallery/4400sqft.jpg",
    "width": 1400,
    "height": 888,
    "type": "landscape",
    "category": "Lifestyle",
    "aspectRatio": "175/111",
    "tailwindAspect": "aspect-[175/111]"
  },
   {
    "id": 2,
    "src": "/images/gallery/exterior-images-28.jpg",
    "width": 1500,
    "height": 750,
    "type": "landscape",
    "category": "Exterior",
    "aspectRatio": "2/1",
    "tailwindAspect": "aspect-[2/1]"
  },
 
   {
    "id": 3,
    "src": "/images/gallery/par.jpeg",
    "width": 1207,
    "height": 845,
    "type": "landscape",
    "category": "Lifestyle",
    "aspectRatio": "1207/845",
    "tailwindAspect": "aspect-[1207/845]"
  },
  {
    "id": 4,
    "src": "/images/gallery/2450sqft.jpg",
    "width": 883,
    "height": 736,
    "type": "landscape",
    "category": "Lifestyle",
    "aspectRatio": "883/736",
    "tailwindAspect": "aspect-[883/736]"
  },
 {
    "id": 5,
    "src": "/images/gallery/1012sqft.jpg",
    "width": 1500,
    "height": 1438,
    "type": "landscape",
    "category": "Lifestyle",
    "aspectRatio": "750/719",
    "tailwindAspect": "aspect-[750/719]"
  },
  {
    "id": 6,
    "src": "/images/gallery/clubhous.jpeg",
    "width": 837,
    "height": 623,
    "type": "landscape",
    "category": "Lifestyle",
    "aspectRatio": "837/623",
    "tailwindAspect": "aspect-[837/623]"
  },
  {
    "id": 7,
    "src": "/images/gallery/1250sqft.jpg",
    "width": 1400,
    "height": 1150,
    "type": "landscape",
    "category": "Lifestyle",
    "aspectRatio": "28/23",
    "tailwindAspect": "aspect-[28/23]"
  },
  {
    "id": 8,
    "src": "/images/gallery/exterior.jpeg",
    "width": 1472,
    "height": 704,
    "type": "landscape",
    "category": "Exterior",
    "aspectRatio": "23/11",
    "tailwindAspect": "aspect-[23/11]"
  },
  {
    "id": 9,
    "src": "/images/gallery/exterior_1125_1.jpg",
    "width": 1500,
    "height": 750,
    "type": "landscape",
    "category": "Exterior",
    "aspectRatio": "2/1",
    "tailwindAspect": "aspect-[2/1]"
  },
  {
    "id": 10,
    "src": "/images/gallery/180.jpeg",
    "width": 403,
    "height": 334,
    "type": "landscape",
    "category": "Lifestyle",
    "aspectRatio": "403/334",
    "tailwindAspect": "aspect-[403/334]"
  },
 
  {
    "id": 11,
    "src": "/images/gallery/pool.jpeg",
    "width": 1043,
    "height": 741,
    "type": "landscape",
    "category": "Lifestyle",
    "aspectRatio": "1043/741",
    "tailwindAspect": "aspect-[1043/741]"
  }
];
